import { useEffect, useRef } from "react";
import * as THREE from "three";
import { cloneAndScaleUV } from "./geometryUltis";

export default function useDoorBoundingDataChecker({ nodes, door, onBoundingDataChanged }) {
  const lastBoundingDataRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (
        nodes?.Door_Single_Frame?.geometry &&
        nodes?.Mesh012?.geometry &&
        nodes?.Mesh012_1?.geometry
      ) {
        const scaledFrameGeometry = cloneAndScaleUV(
          nodes.Door_Single_Frame.geometry, 1,
          door.height / 100, door.width / 100 / 1.5, door.width / 100 / 1.5, door.height / 100
        );
        const scaledMesh012Geometry = cloneAndScaleUV(
          nodes.Mesh012.geometry, 1,
          door.height / 100, door.width / 100 / 1.5, door.width / 100 / 1.5, door.height / 100
        );
        const scaledMesh0121Geometry = cloneAndScaleUV(
          nodes.Mesh012_1.geometry, 1,
          door.height / 100, door.width / 100 / 1.5, door.width / 100 / 1.5, door.height / 100
        );

        const tempGroup = new THREE.Group();
        tempGroup.add(
          new THREE.Mesh(scaledFrameGeometry),
          new THREE.Mesh(scaledMesh012Geometry),
          new THREE.Mesh(scaledMesh0121Geometry)
        );

        const box = new THREE.Box3().setFromObject(tempGroup);
        const size = new THREE.Vector3();
        const center = new THREE.Vector3();
        box.getSize(size);
        box.getCenter(center);

        const newBoundingData = { box, size, center };

        const boundingDataEquals = (a, b) => {
          if (!a || !b) return false;
          return (
            a.size.distanceTo(b.size) < 1e-5 &&
            a.center.distanceTo(b.center) < 1e-5
          );
        };

        if (
          door.boundingData == null ||
          !boundingDataEquals(door.boundingData, newBoundingData) ||
          lastBoundingDataRef.current == null ||
          !boundingDataEquals(lastBoundingDataRef.current, newBoundingData)
        ) {
          onBoundingDataChanged(newBoundingData);
          lastBoundingDataRef.current = newBoundingData;
        }
      }
    }, 100);

    return () => clearInterval(interval);
  }, [nodes, door.height, door.width, door.boundingData, onBoundingDataChanged]);
}
